import request from '@/utils/request'
import { getShopId } from "@/api/shop/shopApi"

// 获取菜单目录
export function _getMenuCatalog() {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.listCatalog',
      method: 'get',
      params: {
        page: 1,
        row: 10,
        isShow: 'Y',
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取菜单列表
export function getMenuList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/plugin/menu.listMenu',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加菜单
export function addMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/plugin/menu.saveMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新菜单
export function updateMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/plugin/menu.updateMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除菜单
export function deleteMenu(mId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/plugin/menu.deleteMenu',
      method: 'post',
      data: { mId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取菜单树
export function getMenuTree(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.listCatalogMenus',
      method: 'get',
      params: {
        caId: params.caId,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 跳转到商城
export function jumpToMall(url) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mall.getMallToken',
      method: 'get',
      params: {
        targetUrl: encodeURIComponent(url),
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        let _url = res.data.url;
        window.open(_url);
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 跳转到IoT
export function jumpToIot(url) {
  return new Promise((resolve, reject) => {
    request({
      url: '/iot.getIotToken',
      method: 'get',
      params: {
        targetUrl: encodeURIComponent(url),
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        let _url = res.data.url;
        window.open(_url);
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 跳转到插件
export function jumpToPlugin(url) {
  return new Promise((resolve, reject) => {
    request({
      url: '/plugin.getPluginToken',
      method: 'get',
      params: {
        targetUrl: encodeURIComponent(url),
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}